import { Component } from '@angular/core';
//import { OpenIdConnectService } from '../services/security/open-id-connect.service';
import { OnInit } from '@angular/core';
import { DashboardService } from '../modules/dashboard/shared/dashboard.service';
import { Router } from '@angular/router';
import { SettingsProviderService } from '../settings-provider.service';
import { Local } from 'protractor/built/driverProviders';
import { AuthService } from '../services/security/auth.service';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html'
})
export class NavMenuComponent implements OnInit {

  constructor(
    private authService: AuthService,
    private dashboardService: DashboardService,
    private router: Router,
    private settingsProviderService: SettingsProviderService) { }
  isExpanded = false;

  ngOnInit(): void {

  }

  collapse() {
    this.isExpanded = false;
  }

  toggle() {
    this.isExpanded = !this.isExpanded;
  }

  login(event): void {
    const path = window.location.pathname;
    if (path !== '/signin-oidc') {
      if (!this.authService.currentAuthUser) {
        this.authService.login().subscribe(          
          () => {
            // Success
            console.log('Login successful');
          },
          (error) => {
            // Handle error
            console.error('Login error:', error);
          }
        );  ;
      }
    }
    event.preventDefault();
    event.stopPropagation();
  }

  logout(): void {
    this.authService.logout();
  }

  editProfile(event): void {


    this.authService.editProfile();
  }

  get userAvailable(): boolean {
    return this.authService.currentAuthUser != null;
  }

  get disallowNavigation(): boolean {
    return this.router.isActive("/tutorial", true) || this.router.isActive("/help", true) ;
  }

  get user(): string {
    return this.authService.currentAuthUser.name;
  }

  backToDashboard() {
      this.dashboardService.checkIn().subscribe(result => {
          if (result.isSuccess) {
              this.router.navigateByUrl("/dashboard");
          }
          else {
              alert(result.message);
          }
      }, error => console.error(error));
  }
}
